var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSuccessDiscountCode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.096 1.584-10.05 10.82L8.96 8.121a.756.756 0 1 0-1.225.884l3.626 5.035a.758.758 0 0 0 .567.312h.046a.755.755 0 0 0 .554-.252L23.202 2.612a.756.756 0 0 0-1.109-1.028h.003Z",
    fill: "#7ED9AA",
    stroke: "#7ED9AA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.564 9.015a.756.756 0 0 0-.592.89 9.323 9.323 0 1 1-4.707-6.337.758.758 0 0 0 .726-1.331 10.835 10.835 0 1 0 5.463 7.37.756.756 0 0 0-.89-.592Z",
    fill: "#7ED9AA",
    stroke: "#7ED9AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSuccessDiscountCode);
export default __webpack_public_path__ + "static/media/icon-success-discount-code.1551e8e3.svg";
export { ForwardRef as ReactComponent };